import React from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import { UnionSoftwareType } from 'modules/software_management/lib/software'

interface Props {
  software: UnionSoftwareType
  onSelect: (value: string) => void
}

const Row = ({ software, onSelect }: Props) => {
  const [hover, setHover] = React.useState<boolean>(false)
  const handleClick = () => {
    onSelect(software.id)
  }

  return (
    <Box
      flexDirection="row"
      gap="s12"
      alignItems="center"
      cursor="pointer"
      paddingY="s16"
      paddingX="s32"
      border={{
        bottom: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      background={hover ? 'grey200' : 'grey000White'}
      onClick={handleClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Avatar size="s24" url={software.logoUrl} label={software.name} />
      <Text.Normal color="grey1000" ellipsis>
        {software.name}
      </Text.Normal>
    </Box>
  )
}

export default Row
